import React, { useEffect, useMemo, useState } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { Button, Dropdown, message } from "antd";
import dayjs from "dayjs";
import { fetchShortReports } from "@components/service/reports/report-api";

const formatParamDate = (value) => {
  if (!value) return undefined;
  const date = dayjs(value);
  return date.isValid() ? date.format("YYYY-MM-DD") : undefined;
};

const ReportButton = ({
  vid,
  id,
  ids,
  begPer,
  endPer,
  part,
  idBranch,
  disabled = false,
  compact = false
}) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (vid == null) {
      setReports([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    fetchShortReports(vid)
      .then((data) => {
        if (!cancelled) setReports(Array.isArray(data) ? data : []);
      })
      .catch((e) => {
        if (!cancelled) {
          setReports([]);
          message.error(e.message || "Не удалось загрузить список отчётов");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [vid]);

  const openReport = (reportId) => {
    const params = new URLSearchParams({ reportId: String(reportId) });
    if (id !== null && id !== undefined && id !== "") params.set("id", String(id));
    if (ids !== null && ids !== undefined) {
      const value = Array.isArray(ids) ? ids.filter((item) => item != null).join(",") : String(ids);
      if (value) params.set("ids", value);
    }
    const dateBeg = formatParamDate(begPer);
    const dateEnd = formatParamDate(endPer);
    if (dateBeg) params.set("begPer", dateBeg);
    if (dateEnd) params.set("endPer", dateEnd);
    if (part !== null && part !== undefined && part !== "") params.set("part", String(part));
    if (idBranch !== null && idBranch !== undefined && idBranch !== "") {
      params.set("idBranch", String(idBranch));
    }
    window.open(`/report?${params.toString()}`, "_blank", "noopener,noreferrer");
  };

  const items = useMemo(
    () =>
      reports.map((report) => ({
        key: String(report.id),
        label: report.name,
        onClick: () => openReport(report.id)
      })),
    [reports, id, ids, begPer, endPer, part, idBranch]
  );

  const unavailable = disabled || loading || !reports.length;

  return (
    <Dropdown menu={{ items }} trigger={["click"]} disabled={unavailable}>
      <Button
        icon={<PrinterOutlined />}
        loading={loading}
        disabled={unavailable}
        aria-label="Печать"
        title={!loading && !reports.length ? "Нет доступных отчётов" : "Печать"}
      >
        {compact ? null : "Печать"}
      </Button>
    </Dropdown>
  );
};

export default ReportButton;
